import { Link } from 'react-router-dom';
import { siteConfig } from '@/mocks/siteData';
import SEOHead from '@/components/feature/SEOHead';

export default function About() {
  const breadcrumbSchema = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      { '@type': 'ListItem', position: 1, name: '首页', item: 'https://pgzhengtu.com/' },
      { '@type': 'ListItem', position: 2, name: '关于我们', item: 'https://pgzhengtu.com/about' },
    ],
  };

  const aboutSchema = {
    '@context': 'https://schema.org',
    '@type': 'AboutPage',
    name: '关于PG征途国际',
    description: 'PG征途国际下载安装官方指南平台，致力于为玩家提供最全面、最安全的下载安装服务。',
    url: 'https://pgzhengtu.com/about',
  };

  const reputationItems = [
    { icon: 'ri-download-cloud-2-line', value: '500万+', label: '累计下载量' },
    { icon: 'ri-user-star-line', value: '98%', label: '用户好评率' },
    { icon: 'ri-shield-check-line', value: '100%', label: '安全正版保证' },
    { icon: 'ri-service-line', value: '7×24', label: '客服在线支持' },
  ];

  return (
    <>
      <SEOHead
        title={`关于我们 - ${siteConfig.name}`}
        description={`了解${siteConfig.name}的品牌故事、核心优势与联系方式。官方正版下载安装指南平台，500万+玩家信赖之选。`}
        canonicalUrl="https://pgzhengtu.com/about"
        schemaData={{ ...breadcrumbSchema, ...aboutSchema }}
      />

      <main className="pt-20 pb-14">
        {/* Breadcrumb */}
        <div className="max-w-6xl mx-auto px-4 md:px-6 py-4">
          <nav className="flex items-center gap-2 text-xs text-foreground-500" aria-label="面包屑导航">
            <Link to="/" className="hover:text-primary-600 transition-colors">首页</Link>
            <i className="ri-arrow-right-s-line text-xs"></i>
            <span className="text-foreground-700 font-medium">关于我们</span>
          </nav>
        </div>

        {/* Brand Introduction */}
        <section className="max-w-6xl mx-auto px-4 md:px-6">
          <div className="mb-14">
            <h1 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-6">
              关于PG征途国际
            </h1>
            <div className="bg-background-50 border border-background-200/70 rounded-xl p-6 md:p-8">
              <div className="max-w-3xl">
                <p className="text-foreground-700 leading-relaxed mb-4">
                  PG征途国际下载安装平台是专注于PG征途国际手游官方正版客户端下载与安装指南的专业服务平台。
                  我们致力于为广大玩家提供最安全、最便捷、最全面的PG征途国际下载安装解决方案。
                </p>
                <p className="text-foreground-700 leading-relaxed mb-4">
                  自平台成立以来，我们始终坚持<span className="font-semibold text-foreground-900">"安全第一、用户至上"</span>的服务理念，
                  所有提供的下载资源均来自官方正版渠道，经过严格的安全检测，确保每一位玩家都能放心下载、安心游戏。
                </p>
                <p className="text-foreground-700 leading-relaxed mb-4">
                  我们的团队由资深游戏玩家和技术专家组成，深入理解玩家在下载安装过程中可能遇到的各类问题，
                  精心编写了覆盖安卓、iOS全平台的详细教程，从下载到安装再到常见问题解决，为您提供一站式服务。
                </p>
                <p className="text-foreground-700 leading-relaxed">
                  除了下载安装指南，我们还持续更新PG征途国际的游戏攻略、新手福利领取教程、版本更新资讯等内容，
                  帮助玩家更快上手游戏，享受精彩的游戏体验。
                </p>
              </div>
            </div>

            {/* Stats */}
            <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 mt-6">
              {reputationItems.map((item) => (
                <div key={item.label} className="bg-background-50 border border-background-200/70 rounded-xl p-5 text-center">
                  <div className="w-10 h-10 mx-auto mb-3 rounded-lg bg-primary-100 flex items-center justify-center">
                    <i className={`${item.icon} text-lg text-primary-600`}></i>
                  </div>
                  <div className="text-xl md:text-2xl font-heading font-bold text-foreground-900 mb-1">
                    {item.value}
                  </div>
                  <div className="text-xs text-foreground-500">
                    {item.label}
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Core Values */}
          <section className="mb-14">
            <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900 mb-6">
              我们的优势
            </h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
              <div className="bg-background-50 border border-background-200/70 rounded-xl p-5">
                <div className="w-10 h-10 rounded-lg bg-accent-100 flex items-center justify-center mb-3">
                  <i className="ri-shield-check-line text-lg text-accent-600"></i>
                </div>
                <h3 className="font-heading font-semibold text-foreground-900 mb-2">官方正版保障</h3>
                <p className="text-xs text-foreground-600 leading-relaxed">
                  所有客户端安装包均来自官方渠道，经过数字签名验证和安全扫描，杜绝病毒和恶意软件风险。
                </p>
              </div>
              <div className="bg-background-50 border border-background-200/70 rounded-xl p-5">
                <div className="w-10 h-10 rounded-lg bg-accent-100 flex items-center justify-center mb-3">
                  <i className="ri-guide-line text-lg text-accent-600"></i>
                </div>
                <h3 className="font-heading font-semibold text-foreground-900 mb-2">图文详细教程</h3>
                <p className="text-xs text-foreground-600 leading-relaxed">
                  每一步操作都有详细的图文说明，即使是游戏新手也能轻松完成下载安装全流程。
                </p>
              </div>
              <div className="bg-background-50 border border-background-200/70 rounded-xl p-5">
                <div className="w-10 h-10 rounded-lg bg-accent-100 flex items-center justify-center mb-3">
                  <i className="ri-customer-service-2-line text-lg text-accent-600"></i>
                </div>
                <h3 className="font-heading font-semibold text-foreground-900 mb-2">7×24小时客服</h3>
                <p className="text-xs text-foreground-600 leading-relaxed">
                  专业客服团队全天候在线，随时为您解答下载安装过程中遇到的任何疑问。
                </p>
              </div>
            </div>
          </section>

          {/* Contact Section */}
          <section className="mb-14">
            <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900 mb-6">
              联系我们
            </h2>
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
              <div className="bg-background-50 border border-background-200/70 rounded-xl p-6">
                <h3 className="font-heading font-semibold text-foreground-900 mb-4">联系方式</h3>
                <div className="flex flex-col gap-4">
                  <div className="flex items-start gap-3">
                    <div className="w-9 h-9 rounded-lg bg-primary-100 flex items-center justify-center flex-shrink-0">
                      <i className="ri-mail-line text-primary-600"></i>
                    </div>
                    <div>
                      <p className="text-xs text-foreground-500 mb-0.5">客服邮箱</p>
                      <p className="text-sm font-medium text-foreground-800">support@pgzhengtu.com</p>
                    </div>
                  </div>
                  <div className="flex items-start gap-3">
                    <div className="w-9 h-9 rounded-lg bg-primary-100 flex items-center justify-center flex-shrink-0">
                      <i className="ri-wechat-line text-primary-600"></i>
                    </div>
                    <div>
                      <p className="text-xs text-foreground-500 mb-0.5">官方微信公众号</p>
                      <p className="text-sm font-medium text-foreground-800">PG征途国际</p>
                    </div>
                  </div>
                  <div className="flex items-start gap-3">
                    <div className="w-9 h-9 rounded-lg bg-primary-100 flex items-center justify-center flex-shrink-0">
                      <i className="ri-customer-service-2-line text-primary-600"></i>
                    </div>
                    <div>
                      <p className="text-xs text-foreground-500 mb-0.5">在线客服</p>
                      <p className="text-sm font-medium text-foreground-800">游戏内客服系统 / 官网在线咨询</p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="bg-background-50 border border-background-200/70 rounded-xl p-6">
                <h3 className="font-heading font-semibold text-foreground-900 mb-4">常见咨询</h3>
                <div className="flex flex-col gap-3">
                  <div className="p-3 bg-background-100 rounded-lg">
                    <p className="text-sm font-medium text-foreground-800 mb-1">下载安装咨询</p>
                    <p className="text-xs text-foreground-500">有关PG征途国际客户端下载安装的任何问题，我们都会为您耐心解答。</p>
                  </div>
                  <div className="p-3 bg-background-100 rounded-lg">
                    <p className="text-sm font-medium text-foreground-800 mb-1">账号与安全</p>
                    <p className="text-xs text-foreground-500">账号注册、登录、安全设置等相关问题，请通过官方渠道联系处理。</p>
                  </div>
                  <div className="p-3 bg-background-100 rounded-lg">
                    <p className="text-sm font-medium text-foreground-800 mb-1">合作与商务</p>
                    <p className="text-xs text-foreground-500">商务合作、媒体采访等事宜请发送邮件至合作邮箱。</p>
                  </div>
                </div>
              </div>
            </div>
          </section>

          {/* Disclaimer */}
          <section>
            <div className="bg-background-100 border border-background-200/70 rounded-xl p-5">
              <div className="flex items-start gap-3">
                <div className="w-8 h-8 rounded-lg bg-secondary-200 flex items-center justify-center flex-shrink-0">
                  <i className="ri-information-line text-secondary-600"></i>
                </div>
                <div>
                  <h3 className="font-heading font-semibold text-foreground-900 text-sm mb-2">免责声明</h3>
                  <p className="text-xs text-foreground-600 leading-relaxed">
                    本站为PG征途国际游戏爱好者创建的下载安装指南平台，与游戏官方开发商无直接关联。
                    本站提供的所有下载资源均来自公开官方渠道，仅供学习交流使用。游戏版权归原开发商所有。
                    如发现下载资源存在异常，请及时联系我们处理。
                  </p>
                </div>
              </div>
            </div>
          </section>
        </section>
      </main>
    </>
  );
}